<template>
  <div class="privacy-summary-cmp" @click="hiddenLanguageOptions">
    <switch-i18n ref="i18nRef" />
    <div class="article-wrapper">
      <h1>{{ appName }}{{ $t('common.privacySummaryTitle') }}</h1>
      <slot name="app-desc"></slot>
      <p>{{ $t('common.privacySummary01', { company: companyName }) }}<a href="./privacy.html" target="_blank">{{ $t('common.privacySummary02') }}</a>{{ $t('common.privacySummary03') }}</p>
      <h2>{{ $t('common.privacySummaryTitle01') }}</h2>
      <p>{{ $t('common.privacySummary04') }}</p>
      <p>{{ $t('common.privacySummary05') }}</p>
      <p>{{ $t('common.privacySummary06') }}</p>
      <p>{{ $t('common.privacySummary07') }}</p>
      <p>{{ $t('common.privacySummary08') }}</p>
      <h2>{{ $t('common.privacySummaryTitle02') }}</h2>
      <p>{{ $t('common.privacySummary09') }}</p>
      <h2>{{ $t('common.privacySummaryTitle03') }}</h2>
      <p>{{ $t('common.privacySummary10') }}</p>
      <h2>{{ $t('common.privacySummaryTitle04') }}</h2>
      <p>{{ $t('common.privacySummary11') }}</p>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { useTitle } from '@/hooks/useTitle'
import { useHideLanguageOptions } from '@/hooks/useHideLanguageOptions';
import SwitchI18n from "@/components/switch_i18n.vue"

// 定义属性
defineProps({
  appName: {
    type: String,
    default: '',
  },
  companyName: {
    type: String,
    required: true,
  },
});

// 监听到语言发生改变后修改标题
useTitle('common.privacySummaryTitle');

// 点击空白区域隐藏语言选择框
const { i18nRef, hiddenLanguageOptions } = useHideLanguageOptions();
</script>

<style lang="less">
</style>
